export default __webpack_public_path__ + "static/assets/med_pill_round_out_L1_solid_l_01_f.75992056.png";